import * as React from "react";
import { DataGrid, DataGridProps } from "@mui/x-data-grid";

// Wrapper to smooth over versioned prop typing differences
// Usage: <DataGridCompat {...props} />
export const DataGridCompat: React.FC<Partial<DataGridProps> & any> = (props) => {
    return <DataGrid {...(props as any)} />;
};

export default DataGridCompat;


